module.exports = __webpack_public_path__ + "static/media/briefcase.c08db62c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wheel_icons/briefcase.svg
// module id = 959
// module chunks = 2